// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const calyrex_ice: PokeData = {
  "id": 10193,
  "name": "calyrex-ice",
  "height": 24,
  "weight": 8091,
  "base_experience": 340,
  "types": [
    PokeType.PSYCHIC,
    PokeType.ICE
  ],
  "api_moves": [
    "pound",
    "swords-dance",
    "stomp",
    "double-kick",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "tail-whip",
    "mist",
    "mega-drain",
    "leech-seed",
    "growth",
    "solar-beam",
    "confusion",
    "psychic",
    "giga-drain",
    "future-sight",
    "torment",
    "taunt",
    "helping-hand",
    "aromatherapy",
    "iron-defense",
    "energy-ball",
    "avalanche",
    "psyshock",
    "heal-pulse",
    "icicle-crash",
    "grassy-terrain",
    "life-dew",
    "glacial-lance"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "solar-beam",
    "psychic",
    "future-sight",
    "aromatherapy",
    "energy-ball",
    "avalanche",
    "grassy-terrain",
    "life-dew",
    "aurora-veil",
    "synchronize",
    "calm-mind"
  ],
  "evolution_chain": {
    "id": 476,
    "item": null,
    "species": [
      {
        "name": "calyrex",
        "order": 898,
        "types": [
          PokeType.PSYCHIC,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 143,
    "speed": 60,
    "ability_power": 197
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
